import { FC, useEffect, useState } from "react";
import AppAddEditSupplier from "../app-add-supplier/app-add-supplier";
import { serviceAreas } from "../../services/service-areas";
import appState from "../../state/AppStateContainer";
import styles from "./page-supplier-signup.module.scss";
import Card from "../../components/shared/Card/card";
import BtButton from "../bt-button/bt-button";
import { RouteComponentProps } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';
import LanguageSwitcher from "../../controls/LanguageSwitcher/LanguageSwitcher";

type Props = {} & RouteComponentProps
type Area = { name: string, _id: string }
type BigNumbers = {
  contactedSuppliers: number,
  activeBidCards: number,
  finishedDeals: number,
  activeUsers: number,
  amountInBillionSEK: string,
}

const SupplierSignup : FC<Props> = ({ history }) => {
  const [t] = useTranslation('newSupplier', { keyPrefix: 'application' });
  const [areas, setAreas] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [bigNumbers, setBigNumbers] = useState<BigNumbers>();

  useEffect(() => {
    (async () => {
      try {
        const response = await fetch("https://accurator-report-test.azurewebsites.net/api/BigNumbersForWebsiteGet?code=6ToS24vUb5I83KQsYTit-P30voc5che5u3Ti0aturchiAzFuze0KOw%3D%3D");
        setBigNumbers(await response.json());
      } catch (e) { }
    })();
  }, [])


  const renderFooter = () => {
    return (
      <footer className='bidFormFooter'>
        <img src="https://cdn.prod.website-files.com/60ca0e6159e2663916316a16/67d0ef99ab5d5a6fcc0e4f66_Logos_Accurator.png" alt="Accurator" width="175" height="60" />
        <Trans t={t} i18nKey="footer" components={{a: <a />, em: <em /> }} />
      </footer>
    )
  }

  const fetchAreas = async () => {
    const areasData = await serviceAreas.getAreas();
    const areas = areasData.forEach((item : Area) => ({ label: item.name, value: item._id }));
    setAreas(areas);
  };

  const orgName = appState.getCurrentOrgName();

  return <>
    <img src={appState.getCurrentOrgSlug() === 'superadmin' ? 'https://cdn.prod.website-files.com/60ca0e6159e2663916316a16/67126501e015ba6ed36cb0c8_Svartlogohoris8.svg' : `/api/organizations/${appState.getCurrentOrgSlug()}/logo`} style={{display: "block", margin: "2em auto", maxWidth: "350px"}} />
    <LanguageSwitcher className={styles.langswitcher} />
    {submitted ? (<>
      <Card className={styles.signup} title={t('submitted.heading', 'Ansökan skickad')}>
        <Trans t={t} i18nKey="submitted.intro" values={{orgName}} components={{ b: <b /> }} />
      </Card>
      <Card className={styles.signup} title={t('accountPromotion.heading', 'Leverantörskonto')}>
        <Trans t={t} i18nKey="accountPromotion.intro" components={{ b: <b /> }} />
        {bigNumbers && (
          <div className={styles.bigNumbers}>
            <p>{t('accountPromotion.numbers.title', 'Accurator i siffror:')}</p>
            <div className={styles.row}>
              <div>
                <div className={styles.number}>{bigNumbers.contactedSuppliers}</div>
                <div className={styles.label}>{t('accountPromotion.numbers.label.contactedSuppliers', 'Kontaktade leverantörer')}</div>
              </div>
              <div>
                <div className={styles.number}>{bigNumbers.activeBidCards}</div>
                <div className={styles.label}>{t('accountPromotion.numbers.label.activeBidCards', 'Pågående upphandlingar')}</div>
              </div>
              <div>
                <div className={styles.number}>{bigNumbers.finishedDeals}</div>
                <div className={styles.label}>{t('accountPromotion.numbers.label.finishedDeals', 'Avslutade affärer')}</div>
              </div>
              <div>
                <div className={styles.number}>{bigNumbers.activeUsers}</div>
                <div className={styles.label}>{t('accountPromotion.numbers.label.activeUsers', 'Inköpare')}</div>
              </div>
              <div>
                <div className={styles.number}>{bigNumbers.amountInBillionSEK.replace(".", ",")} {t('accountPromotion.numbers.amountUnit', 'mdkr')}</div>
                <div className={styles.label}>{t('accountPromotion.numbers.label.amount', 'Upphandlat')}</div>
              </div>
            </div>
          </div>
        )}
        <iframe src="https://accurator.se/kunder" width="100%" height="210" frameBorder="0" scrolling="no"></iframe>
        <div className={styles.signupButton}><BtButton onClick={() => history.push('/supplier-sign-up')}>{t('accountPromotion.signupButton', 'Skapa leverantörskonto')}</BtButton></div>
      </Card>
    </>) : (
      <Card className={styles.signup} title={t('heading', 'Leverantörsansökan', {context: appState.getCurrentOrgSlug() === 'superadmin' ? 'superadmin' : null})}>
        <div className={styles.intro}>
          <Trans t={t} i18nKey="intro" context={appState.getCurrentOrgSlug() === 'superadmin' ? 'superadmin' : ''} values={{orgName}} components={{ a: <a /> }} />
        </div>

        <AppAddEditSupplier
          supplierApplication
          show
          setShow={() => {}}
          saveSupplier={() => {
            setSubmitted(true);
          }}
          editSupplierData={ {
            name: '',
            supplierId: '',
            areaIds: [],
            organizationNumber: '',
            description: '',
          }}
          onModalHide={() => {}}
          fetchNewAreas={fetchAreas}
          areas={areas}
        />
      </Card>
    )}
    {renderFooter()}
  </>;
}

export default SupplierSignup;
